// src/components/landing/Footer.jsx
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import instagramIcon from '../../assets/images/32px-Instagram.svg.png';
import linkedinIcon from '../../assets/images/32px-LinkedIn_icon.svg.png';
import youtubeIcon from '../../assets/images/youtube.svg';

const Footer = () => {
  return (
    <footer className="bg-[#0A0A0A] py-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            className="flex flex-col items-center"
          >
            <h3 className="text-white text-lg font-semibold mb-4 text-center">WriteApp</h3>
            <p className="text-gray-400 text-sm text-center">
              Discover the science of handwriting analysis and join our community of enthusiasts and professionals.
            </p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="flex flex-col items-center"
          >
            <h3 className="text-white text-lg font-semibold mb-4 text-center">Quick Links</h3>
            <div className="flex flex-col items-center space-y-2">
              <div className="flex space-x-4">
                <Link to="/contact" className="text-gray-400 text-sm hover:text-white transition-colors duration-300">
                  Contact
                </Link>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
            className="flex flex-col items-center"
          >
            <h3 className="text-white text-lg font-semibold mb-4 text-center">Legal</h3>
            <div className="flex flex-col items-center space-y-2">
              <Link to="/privacy" className="text-gray-400 text-sm hover:text-white transition-colors duration-300">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-400 text-sm hover:text-white transition-colors duration-300">
                Terms of Service
              </Link>
              <Link to="/cookies" className="text-gray-400 text-sm hover:text-white transition-colors duration-300">
                Cookie Policy
              </Link>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="flex flex-col items-center"
          >
            <h3 className="text-white text-lg font-semibold mb-4 text-center">Connect</h3>
            <div className="flex space-x-4 mb-4">
              <motion.a
                href="https://www.instagram.com/graphologist_pareshchitnis/"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.1, transition: { duration: 0.2 } }}
              >
                <img src={instagramIcon} alt="Instagram" className="w-6 h-6" />
              </motion.a>
              <motion.a
                href="https://www.linkedin.com/in/pareshchitnis/"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.1, transition: { duration: 0.2 } }}
              >
                <img src={linkedinIcon} alt="LinkedIn" className="w-6 h-6" />
              </motion.a>
              <motion.a
                href="https://www.youtube.com/user/pareshchitnis"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.1, transition: { duration: 0.2 } }}
              >
                <img src={youtubeIcon} alt="Youtube" className="w-6 h-6" />
              </motion.a>
            </div>
            <div className="text-gray-400 text-sm text-center">
              Follow us on social media for updates and insights
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="border-t border-gray-800 mt-8 pt-6 text-center"
        >
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} WriteApp. All rights reserved.
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;